// extracted by mini-css-extract-plugin
module.exports = {"ChevronTitle":"ChevronTitle_ChevronTitle__1vXFW","ArrowIcon":"ChevronTitle_ArrowIcon__Y1JAo","shiftDown":"ChevronTitle_shiftDown__2QL5D"};